import Overview from './overview.vue';
import MobOverview from './mob-overview.vue';
import Full from './full.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull,

	// pure 简览外链：零样式直出，复用 overview 简览视图，高度交由消费方控制
	pure: Overview,
	'mob-pure': MobOverview
};
